export default class PortfolioError extends Error {
  constructor(message, faultCode, context) {
    super(message);
    this.faultCode = faultCode;
    this.context = context;
  }
}



// WEBPACK FOOTER //
// ./src/portfolio-shared/util/PortfolioError.js